import React from 'react';
import { Modal } from 'react-bootstrap';
import CreateDirectQuotation from '../../widgets/forms/setup/Create_Quotation';

function CreateDirectQuotationModal(props) {
  return (
    <div>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal-width"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Create Direct Quotation</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateDirectQuotation onHide={props.onHide} fetchQuotations={props.fetchQuotations} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CreateDirectQuotationModal;